import { useEffect, useState } from "react";
import { Receipt } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { productApi } from "@/lib/api";
import { ProductModeBanner } from "@/components/ProductModeBanner";

const STATUS = { draft: "bg-slate-100 text-slate-600", requested: "bg-amber-50 text-amber-700", pending: "bg-amber-50 text-amber-700", paid: "bg-emerald-50 text-emerald-700", cancelled: "bg-red-50 text-red-600" };
const H = "text-xs font-semibold text-slate-500 uppercase tracking-wider py-2 px-3";

export default function ProductBilling() {
  const [rows, setRows] = useState(null);
  useEffect(() => { productApi.getInvoices().then((r) => setRows(r.data)).catch(() => setRows([])); }, []);

  return (
    <div className="p-4 md:p-6 space-y-5" data-testid="product-billing-page">
      <ProductModeBanner />
      <div>
        <h1 className="text-xl font-bold text-slate-900 tracking-tight" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>Billing</h1>
        <p className="text-sm text-slate-500 mt-0.5">Read-only invoice list. SLDP invoices can include web-indexing earnings, so their amounts are unavailable.</p>
      </div>
      <div className="bg-white border border-slate-200 rounded-xl overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow className="bg-slate-50">
              <TableHead className={H}>Invoice</TableHead><TableHead className={H}>Partner</TableHead><TableHead className={H}>Type</TableHead>
              <TableHead className={H}>Month</TableHead><TableHead className={H}>Status</TableHead><TableHead className={`${H} text-right`}>Amount</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows === null ? (
              <TableRow><TableCell colSpan={6} className="text-center py-10 text-slate-400">Loading...</TableCell></TableRow>
            ) : rows.length === 0 ? (
              <TableRow><TableCell colSpan={6} className="text-center py-10 text-slate-400"><Receipt size={24} className="mx-auto mb-2 text-slate-300" />No invoices</TableCell></TableRow>
            ) : rows.map((r) => (
              <TableRow key={r.invoice_id} className="border-b border-slate-100" data-testid={`product-invoice-row-${r.invoice_id}`}>
                <TableCell className="py-2 px-3 text-sm font-mono text-slate-700">{r.invoice_number}</TableCell>
                <TableCell className="py-2 px-3 text-sm text-slate-800">{r.partner_name}</TableCell>
                <TableCell className="py-2 px-3 text-xs font-semibold text-slate-500 uppercase">{r.partner_type}</TableCell>
                <TableCell className="py-2 px-3 text-sm text-slate-600">{r.month}</TableCell>
                <TableCell className="py-2 px-3"><span className={`text-[11px] font-semibold px-2 py-0.5 rounded-full ${STATUS[r.status] || STATUS.draft}`}>{r.status}</span></TableCell>
                <TableCell className="py-2 px-3 text-sm text-right font-mono" data-testid={`product-invoice-amount-${r.invoice_id}`}>
                  {r.amount_redacted ? <span className="text-slate-400 italic font-sans text-xs">Unavailable</span> : `${r.currency === "INR" ? "₹" : "$"}${Number(r.amount || 0).toFixed(2)}`}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
